import React, { useState, useEffect } from "react";
import checkmark3 from "./subscriptionassets/checkmark-3.png";
import image from "./subscriptionassets/circle.png";
import "./subscriptionstyle.css";

export const SubscriptionTile = ({ price, title, features, stripe_product, hasValidSubscription, onPurchase }) =>
{

  const [isActivated, setIsActivated] = useState(hasValidSubscription);

  useEffect(() =>
  {
    console.log("Stripe Product: ", stripe_product);
  }, [stripe_product]);

  // Handle the activation
  const onActivate = () =>
  {
    setIsActivated(true);
  };

  return (
    <div className="business">
      {/* Title at the Top */}
      <div className="listing-subscription">

        <p class="listing-heading"> {title}
        </p>
        <span className="price-tag themeBlue_btn"><span>${price}</span>/m</span>


      </div>

      {/* Features in the Middle */}
      <div className="point">
        {features && features.map((feature, index) => (
          <div key={index} className="feature-item">
            <img className="checkmark-3" alt="Checkmark" src={checkmark3} />
            <span>{feature}</span>
          </div>
        ))}
      </div>




      <div className="purchasebtn-outer">
        {/* Purchase Button */}
        {hasValidSubscription ? (
          <button className="purchasebtn purchasebtn-activated" disabled>Activated</button>
        ) : (
          <button className="purchasebtn" onClick={() => onPurchase(title, stripe_product)}>Purchase</button>
        )}

      </div>
    </div>
  );
};

export default SubscriptionTile;